<script>
import constants from '@/constants';

export default {
    ANALYTICS_TABS: constants.ANALYTICS_TABS,
    props: {
        activeTab: {
            type: String,
            required: true,
            validator: (value) =>
                Object.values(constants.ANALYTICS_TABS).includes(value),
        },
    },
    emits: ['update:activeTab'],
    methods: {
        switchTab(tab) {
            if (tab !== this.activeTab) {
                this.$emit('update:activeTab', tab);
            }
        },
    },
};
</script>

<template>
    <div class="tabs_container">
        <div class="tabs_header">
            <button
                :class="[
                    'tab_button',
                    { active: activeTab === $options.ANALYTICS_TABS.GENERAL },
                ]"
                @click="switchTab($options.ANALYTICS_TABS.GENERAL)"
            >
                General Data
            </button>
            <button
                :class="[
                    'tab_button',
                    {
                        active:
                            activeTab === $options.ANALYTICS_TABS.SEARCH_QUERIES,
                    },
                ]"
                @click="switchTab($options.ANALYTICS_TABS.SEARCH_QUERIES)"
            >
                Search Queries
            </button>
        </div>
    </div>
</template>

<style scoped>
.tabs_container {
    margin-bottom: 20px;
}

.tabs_header {
    display: flex;
    gap: 10px;
    border-bottom: 2px solid var(--border-color);
}

.tab_button {
    padding: 12px 24px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    color: var(--text-secondary);
    transition: all 0.2s ease;
    margin-bottom: -2px;
}

.tab_button:hover {
    color: var(--text-color);
    background: var(--hover-background);
}

.tab_button.active {
    color: var(--main-color);
    border-bottom-color: var(--main-color);
}
</style>
